<template>
  <div :class="colorclass">
      <label >{{titleWithOverride}}</label>
      <label class="gianttext">{{count}}</label>
      <label >{{amount | toCurrency}}</label>
  </div>
</template>

<script>
import format from '../../format.js'
export default {
    name:'summarybox',
    components:{

    },
    props:{
        title:{
            type:String,
        },
        count:{
            type:Number
        },
        amount:{
            type:Number
        },
        background:{
            type:String
        }
        
    },
    mixins:[format],
    computed:{
        titleWithOverride(){
            var over =this.title.replaceAll('Product',this.productText)
            return over
        },
        productText(){
            if(window.PRODUCT_TEXT_OVERRIDE==undefined){return "Product"}
            else{return window.PRODUCT_TEXT_OVERRIDE}
        },
        colorclass(){
            switch (this.background) {
                case 'green':
                    return 'filled lightgreen'
                    break;
                case 'blue':
                    return 'filled lightblue'
                    break;
                case 'red':
                    return 'filled lightred'
                    break;
                case 'tan':
                    return 'filled lighttan'
                    break;
                default:
                    break;
            }
        }
    }
}
</script>

<style scoped>
.filled{
    /* border:darkgray 1px solid; */
    display:flex;
    flex-direction: column;
    padding:10px;
    margin:5px;
    min-width:80px;
    
}


.gianttext{
    font-size:xx-large;
}
.lightred{
    background-color:rgb(243, 178, 178);
}
.lighttan{
    background-color:rgb(247, 247, 172);
}
.lightblue{
    background-color:rgb(173,191,239);
}
.lightgreen{
    background-color:rgb(171,214,174);
}
</style>